var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"AListIcon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('shopping-bag-icon',{attrs:{"size":".9x"}}),(_vm.count)?_c('a-badge',{attrs:{"count":_vm.count,"position":"top-left"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }